export default __webpack_public_path__ + "static/media/box-icon.8c25ab0f.svg";